/**
 * 预留标记，用来传递给存储模块表示公有数据存储
 */
exports.None = -1;
/**
 * 基础模块，包含基础模块
 */
exports.Base = 0;
/**
 * 公共模块，包含首页，用户信息，注册，登录等
 */
exports.Common = 1;
/**
 * 安检模块
 */
exports.Safecheck = 2;
/**
 * 抄表模块
 */
exports.MeterRead = 3;
/**
 * 工单模块
 */
exports.WorkOrder = 4;
/**
 * 巡检模块
 */
exports.Patrol = 5;
/**
 * Demo
 */
exports.Demo = 100;
